import { Inject, Injectable } from '@angular/core';
import { UserInfoService } from './user-info.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {

  constructor(@Inject(UserInfoService) private userInfoService : UserInfoService) { } 

  // load() : Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     const token = this.userInfoService.getTokenFromSessionCache();
  //     if(token) {
  //       this.userInfoService.setToken(token);
  //     }
  //     resolve("success");
  //   });
  // }

  load() : Promise<any> {
    return new Promise((resolve, reject) => {
      const token = this.userInfoService.getTokenFromSessionCache();
      const userPrivileges = this.userInfoService.getPrivilegesFromSessionCache()?.split(',');
     // console.log(userPrivileges)
      if(token) {
        this.userInfoService.setToken(token);
      }
      if(userPrivileges){
        this.userInfoService.setUserPrivileges(userPrivileges);
      }
      resolve("success");
    });
  }
}
